import React from "react";
import { useMessageStore } from "@/app/store";
import { SocketConnectionStatus } from "@/app/store/types";
import Quoted, { QuotedFrom } from "../chat/Quoted";

export default function ChatInputQuoted({ isMobile = false }) {
  const { setQuotedMsg, quotedMsg, isConnected } = useMessageStore();

  if (!quotedMsg || isConnected !== SocketConnectionStatus.CONNECTED) {
    return;
  }

  return (
    <Quoted
      quotedMsg={quotedMsg}
      onClose={() => setQuotedMsg(undefined)}
      from={QuotedFrom.ChatInput}
      isMobile={isMobile}
    />
  );
}
